import React from 'react';
import SolutionInstallmentExaminationContractCompleteWrapper from 'components/SolutionInstallmentExaminationContractCompleteWrapper/SolutionInstallmentExaminationContractCompleteWrapper';

export default function SolutionInstallmentExaminationContractCompleteContainer() {
    return (
        <SolutionInstallmentExaminationContractCompleteWrapper />
    )
}
